import { FormControl, FormGroup, FormArray, ValidatorFn, Validator, Validators } from "@angular/forms";
import { NdmsValidators } from "../../ui-ndms/forms/ndmsValidators.validators";
import { LookupViewModel } from "../../ui-ndms/view-models/lookup.view-model";

export abstract class FormObjects {

    static Address(initialValue: any = null, validators?: ValidatorFn[], required:boolean = true): FormGroup {
        return new FormGroup({
            firstStreetAddress: new FormControl(initialValue ? initialValue.firstStreetAddress : '', required ? [Validators.required] : []),
            secondStreetAddress: new FormControl(initialValue ? initialValue.secondStreetAddress : ''),
            cityName: new FormControl(initialValue ? initialValue.cityName : '', required ? [Validators.required] : []),
            stateProvince: new FormControl(initialValue ? initialValue.stateProvince : null),
            postalCode: new FormControl(initialValue ? initialValue.postalCode : '', required ? [Validators.required] : [])
        })
    }

    static AddressArray(validators?: ValidatorFn[]): FormArray {
        return new FormArray([
            FormObjects.Address(validators)
        ])
    }

    static Boolean(initialValue: boolean = false, validators?: ValidatorFn[]): FormControl {
        return new FormControl(initialValue, validators);
    }

    static Data(value: any) : FormControl {
        return new FormControl(value);
    }
    static DefaultDate(initialValue, validators?: ValidatorFn[]): FormControl {
        return new FormControl(initialValue, validators)
    }
    static Date(initialValue: string = '', validators?: ValidatorFn[]): FormControl {
        return new FormControl(initialValue, validators)
    }

    static Time(initialValue: string = '', validators?: ValidatorFn[]): FormControl {
        return new FormControl(initialValue, validators)
    }

    static Email(initialValue: string = '', validators?: ValidatorFn[]): FormControl {
        const defaultValidators: ValidatorFn[] = [];

        return new FormControl(initialValue, this.joinValidators(defaultValidators, validators));
    }

    static EmailArray(validators?: ValidatorFn[]): FormArray {
        return new FormArray([
            FormObjects.Email(undefined, validators)
        ]);
    }

    static Lookup(initialValue: any = null,validators?: ValidatorFn[]): FormControl {
        return new FormControl(initialValue, validators)
    }

    static Phone(initialValue: any = null, validators?: ValidatorFn[]): FormGroup {

        return new FormGroup({
            number: new FormControl(initialValue ? initialValue.number : '', (validators && validators.length > 0) ? validators[0] : undefined),
            phoneType: new FormControl(initialValue ? initialValue.phoneType : ''),
            extensionNumber: new FormControl(initialValue ? initialValue.extensionNumber : ''),
            phoneNumberNote: new FormControl(initialValue ? initialValue.phoneNumberNote : ''),
        });
    }

    static PhoneArray(validators?: ValidatorFn[]): FormArray {
        return new FormArray([
            FormObjects.Phone(validators)
        ]);
    }

    static SocialSecurityNumberLastFour(initialValue: string = '', validators?: ValidatorFn[]){
        return this.SocialSecurityNumber(initialValue, validators, true);
    }

    static SocialSecurityNumber(initialValue: string = '', validators?: ValidatorFn[], isLastFour: boolean = false): FormControl {
        const defaultValidators: ValidatorFn[] = !isLastFour ? [NdmsValidators.socialSecurityNumber] : [NdmsValidators.socialSecurityNumberLastFour];

        return new FormControl(initialValue, this.joinValidators(defaultValidators, validators));
    }

    static String(initialValue?: string, validators?: ValidatorFn[]): FormControl {
        return new FormControl(initialValue, validators)
    }

    static Number(initialValue: number | undefined = undefined, validators?: ValidatorFn[]): FormControl {
        return new FormControl(initialValue, validators)
    }

    private static joinValidators(defaultValidators: ValidatorFn[], extraValidators?: ValidatorFn[]): ValidatorFn[] {
        let controlValidators = defaultValidators;

        if (extraValidators) {
            controlValidators = controlValidators.concat(extraValidators);
        }

        return controlValidators;
    }
}